import { LoaderProps } from "@/components/Loader/LoaderProps.ts";
import cn from "classnames";
import { useTranslation } from "react-i18next";

export const Loader = (props: LoaderProps) => {
  const { t } = useTranslation();
  if (props.loading)
    return (
      <div
        className={cn("o-loader-wrapper", {
          "o-loader-wrapper--small": props.small,
          "o-loader-wrapper--inline": props.inline,
        })}
      >
        <div className="o-loader u-p1">
          {props?.component ? (
            props.component
          ) : (
            <div className="c-be-loader">
              <i className="c-be-loader__icon">
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.21875 10.2205C0.21875 4.6975 4.69591 0.220215 10.2187 0.220215C15.7416 0.220215 20.2188 4.6975 20.2188 10.2205C20.2188 15.7435 15.7416 20.2208 10.2187 20.2208C4.69591 20.2208 0.21875 15.7435 0.21875 10.2205ZM10.2187 1.36408C5.32763 1.36408 1.36258 5.32924 1.36258 10.2205C1.36258 15.1118 5.32763 19.0769 10.2187 19.0769C15.1099 19.0769 19.0749 15.1118 19.0749 10.2205C19.0749 5.32924 15.1099 1.36408 10.2187 1.36408Z"
                    fill={props.customFill ?? "#04172F"}
                  />
                  <path
                    d="M12.2671 6.3983H8.2703C8.06715 6.3983 7.96312 6.15506 8.10353 6.00841L10.1019 3.92129C10.1928 3.82637 10.3446 3.82637 10.4355 3.92129L12.4338 6.00841C12.5742 6.15506 12.4702 6.3983 12.2671 6.3983Z"
                    fill="#F23535"
                  />
                </svg>
              </i>
              {props.showLabel && <span className="c-be-loader__label">{t("loading")}</span>}
            </div>
          )}
        </div>
      </div>
    );
};
